/* eslint-disable */
import React from 'react';
import { ReferenceField, TextField, useTranslate } from 'react-admin';
import resourceSlug, { REPORT_TYPES } from '../../../../constant/resource-slug';
import { LIST_REPORTS } from '../../report-sales-and-profit.list';
import CustomReportTable from '../../../../base/components/reports/CustomReportTable';
import TranslatableField from '../../../../base/components/ra/fields/translatable.field';
import BaseCurrencyField from '../../../../base/components/reports/ReportTable/BaseCurrencyField';
import { useReportContext } from '../../../../base/components/reports/ReportLayout';

const StandardTable = () => {
  const translate = useTranslate();
  const { appliedFilters } = useReportContext();

  return (
    <CustomReportTable
      title={translate('resources.report.standard')}
      reportType={REPORT_TYPES.STANDARD}
      reportList={LIST_REPORTS}
      resource={resourceSlug.REPORT_SALES_AND_PROFIT}
    >
      <ReferenceField source="group" reference="group" label="resources.group.name" link="show">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField source="brand" reference="brand" label="resources.brand.name" link="show">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField source="gameId" reference="game" label="resources.game.fields.gameId" link="show">
        <TextField source="gameId" />
      </ReferenceField>
      <TranslatableField label="resources.report.fields.game" source="gameName" />
      <TextField label="resources.report.fields.gameType" source="gameType" />
      <TextField label="resources.bet.fields.channel" source="channel" />
      <TextField label="resources.report.fields.betType" source="betType" />
      <TextField label="resources.report.fields.betCount" source="betCount" sortable />
      <TextField label="resources.report.fields.playerCount" source="playerCount" sortable={false} />
      <TextField label="resources.report.fields.currencyType" source="currencyType" sortable={false} />
      <ReferenceField source="currency" reference="currency" label="resources.currency.name" link="show">
        <TextField source="code" />
      </ReferenceField>
      {Boolean(appliedFilters.consolidated) && <BaseCurrencyField label="resources.report.fields.baseCurrency" />}
      <TextField label="resources.report.fields.turnOver" source="turnover" sortable />
      <TextField label="resources.report.fields.wonAmount" source="wonAmount" sortable />
      <TextField label="resources.report.fields.GGR" source="GGR" sortable />
    </CustomReportTable>
  );
};

export default StandardTable;
